import React, { useState } from 'react';
import { Mail, X, CheckCircle2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const EmailVerificationBanner: React.FC = () => {
  const { user, resendEmailConfirmation } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  // Don't show banner if email is confirmed or user doesn't exist
  if (!user || user.email_confirmed_at || isDismissed) {
    return null;
  }

  const handleResend = async () => {
    if (!user.email) return;

    setIsResending(true);
    setResendSuccess(false);

    try {
      const { error } = await resendEmailConfirmation(user.email);
      if (!error) {
        setResendSuccess(true);
        setTimeout(() => setResendSuccess(false), 3000);
      }
    } catch (err) {
      console.error('Failed to resend confirmation email:', err);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="bg-amber-50 dark:bg-amber-950/20 border-b border-amber-200 dark:border-amber-900/50 px-4 py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <Mail size={16} className="text-amber-600 dark:text-amber-400 shrink-0" />
          <p className="text-sm text-amber-800 dark:text-amber-200">
            Please verify your email to secure your account
          </p>
        </div>
        <div className="flex items-center gap-3">
          {resendSuccess && (
            <div className="flex items-center gap-1.5 text-xs text-amber-700 dark:text-amber-300">
              <CheckCircle2 size={14} />
              <span>Sent!</span>
            </div>
          )}
          <button
            onClick={handleResend}
            disabled={isResending}
            className="text-sm font-medium text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isResending ? 'Sending...' : 'Resend verification email'}
          </button>
          <button
            onClick={() => setIsDismissed(true)}
            className="text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200 transition-colors"
            aria-label="Dismiss banner"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

